import classNames from 'classnames';
import { FC, useContext } from 'react';
import { useLocation } from 'react-router';

import { StylesheetContext } from '../../contexts/StylesheetContext';
import { TicketRoutePaths } from '../../interfaces/Routes';
import { isPathInRoutes } from '../../services/RouteService';
import { PreFooter } from '../PreFooter/PreFooter';
import { TermsAndConditions } from '../TermsAndConditions/TermsAndConditions';
import style from './Footer.module.scss';

interface FooterProps {
  hideHelpSection?: boolean;
}

const Footer: FC<FooterProps> = ({ hideHelpSection }) => {
  const { stylesheet } = useContext(StylesheetContext);
  const { pathname } = useLocation();
  const shouldHideFooter = pathname.includes(`/${TicketRoutePaths.contact}`);

  if (shouldHideFooter) {
    return null;
  }

  const { settings: { partnerName, termsUrl }, contact: { onlyMentionPartnerInFooter } } = stylesheet;
  const isPageWithWhiteBackground = isPathInRoutes(
    pathname, [
      TicketRoutePaths.customer,
      TicketRoutePaths.contact,
      TicketRoutePaths.faq,
    ]);
  const wraperClass = classNames(style.wrapper, !isPageWithWhiteBackground && style.withBorderRadius);

  return (
    <footer>
      <div className={wraperClass}>
        <div className="container">
          <PreFooter hideHelpSection={hideHelpSection} />
          <TermsAndConditions
            link={termsUrl}
            onlyMentionPartnerInFooter={onlyMentionPartnerInFooter}
            partner={partnerName}
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
